import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_Cockpit_Vitals.scss';
import { findingViewSectionType_Graph, findingViewType_Sections } from '@app/advisor-ui-shared';
import { ModuleFE_Advisor_FindingView } from '@app/advisor-frontend';
import { AdvisorConfigKeyFE_FindingView_Cockpit } from '@app/advisor-frontend';
import { _values, exists, filterInstances, flatArray, getMax } from '@nu-art/ts-common';
import { Component_FindingViewSection } from '../../../panels/AdvisorPanel_Findings/components/Component_FindingViewSection/Component_FindingViewSection.js';
import { translateGraphResults } from '../../../panels/AdvisorPanel_Findings/components/Component_FindingViewSection/utils.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
export class Component_Cockpit_Vitals extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        const config = AdvisorConfigKeyFE_FindingView_Cockpit.get();
        state.vitalsFindingView = ModuleFE_Advisor_FindingView.cache.unique(config?.vitalsFindingViewId);
        return state;
    }
    //######################### Logic ##########################
    focusVital = (index) => {
        const newVal = index === this.state.focusedVitalIndex ? undefined : index;
        this.setState({ focusedVitalIndex: newVal });
        //Report analytics event
        if (!exists(newVal))
            return;
        const section = this.state.vitalsFindingView?.sections[newVal];
        if (!section)
            return;
        ModuleFE_AdvisorAnalytics.trigger.cockpit.cockpit_widgetFocus({ widgetLabel: section.label });
    };
    getSections = () => {
        if (this.state.vitalsFindingView?.type !== findingViewType_Sections)
            return;
        return this.state.vitalsFindingView.sections.filter(section => section.type === findingViewSectionType_Graph);
    };
    getFocusedSection = () => {
        const sections = this.getSections();
        if (!exists(this.state.focusedVitalIndex) || !sections?.length)
            return;
        return sections[this.state.focusedVitalIndex];
    };
    getSectionValue = (section) => {
        const results = ModuleFE_Advisor_FindingView.getFindingsForSection.graph(section);
        if (!results.length)
            return;
        const translatedResults = translateGraphResults(results);
        const latestTimestamp = getMax(flatArray(_values(translatedResults)), result => result.timestamp)?.timestamp;
        if (!latestTimestamp)
            return;
        const matchingResults = filterInstances(section.data.variableIds.map(id => translatedResults[id]?.find(result => result.timestamp === latestTimestamp)));
        return {
            value: matchingResults.map(result => result.value).join('/'),
            previousEncounter: !matchingResults[0].currentVisit
        };
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'cockpit-panel', id: 'cockpit-key-vitals', children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsx(LL_H_C, { className: 'cockpit-panel__header', children: "Vitals" });
    };
    render_Body = () => {
        const sections = this.getSections();
        if (!sections?.length)
            return;
        return _jsxs(LL_V_L, { id: 'cockpit-vitals', children: [_jsx(LL_H_C, { className: 'cockpit-vitals__cards', children: sections.map(this.render_GraphSection) }), this.render_focusedVital()] });
    };
    render_GraphSection = (section, index) => {
        const sectionValue = this.getSectionValue(section);
        const className = _className('cockpit-vitals__card', index === this.state.focusedVitalIndex && 'focused', exists(sectionValue) && 'selectable');
        const valueClassName = _className('cockpit-vitals__card__value', sectionValue?.previousEncounter && 'fade');
        return _jsxs(LL_H_C, { className: className, onClick: () => {
                if (!sectionValue?.value)
                    return;
                this.focusVital(index);
            }, children: [_jsx("div", { className: 'cockpit-vitals__card__label', children: section.data.abbreviation ?? section.label }), _jsx("div", { className: valueClassName, children: sectionValue?.value ?? 'N/A' })] }, index);
    };
    render_focusedVital = () => {
        const section = this.getFocusedSection();
        if (!section)
            return;
        return _jsx(Component_FindingViewSection, { section: section, hideSectionLabel: true });
    };
}
//# sourceMappingURL=Component_Cockpit_Vitals.js.map